export default {"src":"/_next/static/media/knowledge.6441f0b7.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};